import { EmployeeInviteEntity } from "modules/company/entities";
import { EmployeeInviteDeleteModal } from "modules/company/features";
import React, { CSSProperties, useCallback } from "react";
import { CompanyEmployeeInviteDto } from "shared/api";
import { Modals } from "shared/lib";
import { Empty, IListData, List, MenuItem } from "shared/ui";

export interface IEmployeeInviteList extends IListData<CompanyEmployeeInviteDto> {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const EmployeeInviteList = (props: IEmployeeInviteList) => {
  const onDelete = useCallback(
    (data: CompanyEmployeeInviteDto) =>
      Modals.open(EmployeeInviteDeleteModal, {
        companySlug: props.companySlug,
        data,
        onSuccess: () => props.mutate?.(),
      }),
    [props.companySlug, props.mutate]
  );

  return (
    <List
      {...props}
      empty={<Empty title="Нет приглашений" />}
      renderItem={(it) => (
        <EmployeeInviteEntity
          data={it}
          menuItems={
            <MenuItem type="error" onClick={() => onDelete(it)}>
              Удалить приглашение
            </MenuItem>
          }
        />
      )}
    />
  );
};

EmployeeInviteList.defaultProps = {};
